/**
 * Frontend Product Registry — the extension point for future travel products.
 *
 * To add a new product:
 *  1. Drop a `<product>.js` file in this folder that exports the shape below.
 *  2. Import + register it here.
 *  3. The hero product-switcher, admin dashboard filters, and booking flow
 *     auto-discover it.
 *
 * Each product config:
 *   {
 *     key:        'flights' | 'hotels' | 'cars' | ...
 *     label:      'Flights'
 *     icon:       PhosphorIconComponent
 *     enabled:    true | false  (false => shown as "Coming Soon")
 *     SearchWidget?: React component for the hero search widget
 *     formatBookingSummary?: (booking) => { title, sub, route }
 *   }
 */
import { AirplaneTilt, Buildings, Car, ShieldCheck, MapTrifold, Boat, Star } from "@phosphor-icons/react";
import FlightSearchWidget from "@/components/FlightSearchWidget";

const products = {
  flights: {
    key: "flights",
    label: "Flights",
    icon: AirplaneTilt,
    enabled: true,
    SearchWidget: FlightSearchWidget,
    formatBookingSummary: (b) => ({
      title: `${b.origin} → ${b.destination}`,
      sub: `${b.airline || ""} · ${b.cabin || ""}`,
      route: `${b.depart_date}${b.return_date ? ` · ${b.return_date}` : ""}`,
    }),
  },
  hotels: {
    key: "hotels", label: "Hotels", icon: Buildings, enabled: false,
  },
  cars: {
    key: "cars", label: "Car Rentals", icon: Car, enabled: false,
  },
  transfers: {
    key: "transfers", label: "Airport Transfers", icon: MapTrifold, enabled: false,
  },
  packages: {
    key: "packages", label: "Vacation Packages", icon: Star, enabled: false,
  },
  cruises: {
    key: "cruises", label: "Cruises", icon: Boat, enabled: false,
  },
  insurance: {
    key: "insurance", label: "Travel Insurance", icon: ShieldCheck, enabled: false,
  },
};

export function listProducts() {
  return Object.values(products);
}

export function getProduct(key) {
  return products[key];
}

export default products;
